import { FILTER_CATEGORIES_CONFIG } from '@resources/js/components/filters/filterCategoriesConfig';
const getChipState = (isApplied, isDrafted) => {
    if (isApplied && isDrafted)
        return 'active';
    if (isApplied)
        return 'removed';
    if (isDrafted)
        return 'new';
    return null;
};
// порядок категорій — за FILTER_CATEGORIES_CONFIG, значення — за порядком з API;
// він діє лише при рендері з нуля, далі порядок тримає SelectedFiltersView
export const buildSelectedFilters = ({ applied, draft, filtersData, }) => {
    var _a, _b, _c;
    // поки нічого не застосовано, блок не показуємо — відмітки в панелі чипсами не дублюємо
    const hasApplied = Object.values(applied).some(values => values === null || values === void 0 ? void 0 : values.length);
    if (!hasApplied)
        return [];
    const chips = [];
    for (const category of Object.keys(FILTER_CATEGORIES_CONFIG)) {
        const appliedValues = (_a = applied[category]) !== null && _a !== void 0 ? _a : [];
        const draftValues = (_b = draft[category]) !== null && _b !== void 0 ? _b : [];
        if (!appliedValues.length && !draftValues.length)
            continue;
        for (const option of (_c = filtersData[category]) !== null && _c !== void 0 ? _c : []) {
            const state = getChipState(appliedValues.includes(option.id), draftValues.includes(option.id));
            if (!state)
                continue;
            chips.push({ category, value: option.id, label: option.name, state });
        }
    }
    return chips;
};
